import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const DeleteOmeMeetOrgUnitEntryData = (omeMeetOrgUnitEntryId, referenceEntity, referenceId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const omeMeetOrgUnitEntryIdForUrl = omeMeetOrgUnitEntryId ? encodeURIComponent(omeMeetOrgUnitEntryId) : 'NaN';
    const referenceEntityForUrl = referenceEntity ? encodeURIComponent(referenceEntity) : 'NaN';
    const referenceIdForUrl = referenceId ? encodeURIComponent(referenceId) : 'NaN';
    const url = `/OmeMeetOrgUnitEntryPurchase/OmeMeetOrgUnitEntry/${omeMeetOrgUnitEntryIdForUrl}/CartItem?referenceEntity=${referenceEntityForUrl}&referenceId=${referenceIdForUrl}`;
    MeetHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          })
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteOmeMeetOrgUnitEntryData;